<script setup>

import { ref, onMounted, watch } from "vue";
import ERP from "../../api/v2/ERP.mjs";
import View from "../../api/v2/View.mjs";
import UtilArray from "../../utils/UtilArray.mjs";
import RequisicaoDeCompraService from "../../api/v2/services/RequisicaoDeCompraService.js";
import CotacaoDePedidoDeCompraService from "../../api/v2/services/CotacaoDePedidoDeCompraService.js";
import RetornarRequisicaoModal from './RetornarRequisicaoModal.vue';
import useUsuarioStore from "../../api/v2/stores/UsuarioStore.js";
import useColaboradorStore from "../../api/v2/stores/ColaboradorStore";

const usuarioStore = useUsuarioStore(); 

const colaboradorStore = useColaboradorStore(); 
const compradorNome = ref(colaboradorStore.colaborador.nome);

const requisicoesDeCompra = ref([]);
const requisicoesDeCompraLoading = ref(true);
let requisicoesDeCompraSelecionadas = ref([]);



let jobs = ref([]);
let jobSelecionado = ref("");

let ordensDeServico = ref([]);
let ordemDeServicoSelecionada = ref("");

let palavrasChave = ref([]);
let palavraChaveSelecionada = ref("");

let buscaGeral = ref("");


const retornandoRequisicoes = ref(false);
const criandoCotacoes = ref(false);
const controlesDesativados = ref(false);


const filterJob = (jobCodigo) =>{

    if (!jobSelecionado.value) {
          return true;
    }

    return jobCodigo.toLowerCase().includes(jobSelecionado.value.toLowerCase());

}

const filterOS = (osCodigo) =>{

    if (!ordemDeServicoSelecionada.value) {
        return true;
    }

    return osCodigo.toLowerCase().includes(ordemDeServicoSelecionada.value.toLowerCase());

}

let requisicoesDeCompraHeaders = [
    { text: 'Job',                          value: 'jobCodigo',                              class:"c-table__header",    cellClass:'c-table__item', filter: filterJob},
    { text: 'OS',                           value: 'osCodigo',                               class:"c-table__header",    cellClass:'c-table__item', filter: filterOS},
    { text: 'Sequência',                    value: 'osItemSequencia',                        class:"c-table__header",    cellClass:'c-table__item', filterable: false},
    { text: 'Código do Item',               value: 'osItemItemCodigo',                       class:"c-table__header",    cellClass:'c-table__item', filterable: false},
    { text: 'Descrição',                    value: 'osItemDescricao',                        class:"c-table__header",    cellClass:'c-table__item',  width:"550" },
    { text: 'Data de Solicitação',          value: 'osItemDataSolicitacaoFormatada',         class:"c-table__header",    cellClass:'c-table__item'},
    { text: 'Data de Liberação Compras',    value: 'osItemDataLiberacaoComprasFormatada',    class:"c-table__header",    cellClass:'c-table__item'},
    { text: 'Data de Necessidade',          value: 'osItemDataNecessidadeFormatada',         class:"c-table__header",    cellClass:'c-table__item'},
    { text: 'Quantidade',                   value: 'osItemQuantidade',                       class:"c-table__header",    cellClass:'c-table__item', filterable: false},
    { text: 'Unidade',                      value: 'osItemUnidadeSigla',                     class:"c-table__header",    cellClass:'c-table__item', filterable: false},
    { text: 'Valor Disponivel',             value: 'osItemValorDisponivel',                  class:"c-table__header",    cellClass:'c-table__item', filterable: false,  width:"150" },
    { text: 'Status (Item)',                value: 'osItemStatus',                           class:"c-table__header",    cellClass:'c-table__item', filterable: false},
]

const loadRequisicoesDeCompras = async () =>{
    requisicoesDeCompraSelecionadas.value = [];

    const requisicoesDeCompraResponse = await ERP.getManyWithView(View.REQUISICAO_DE_COMPRA_CRIAR_COTACAO_DE_PEDIDO_DE_COMPRA,[
        {
            name: "owner",
            dataType: "String",
            value: usuarioStore.usuario.id
        },
    ]);
    requisicoesDeCompra.value = requisicoesDeCompraResponse.data;

    fillSelectJobs();
    fillSelectOS();
    clearBuscaGeral();
    fillSelectPalavrasChave();

    requisicoesDeCompraLoading.value = false;
};



const fillSelectJobs = () =>{
    jobSelecionado.value = "";
    jobs.value = requisicoesDeCompra.value.map(({jobCodigo})=>jobCodigo);
};

const fillSelectOS = () =>{
    ordemDeServicoSelecionada.value = "";
    ordensDeServico.value = requisicoesDeCompra.value.map(({osCodigo})=>osCodigo);
};

const fillSelectPalavrasChave = () =>{
    palavraChaveSelecionada.value = "";
    palavrasChave.value = ["Teste1","Teste2"];
};

const clearBuscaGeral = () =>{
    buscaGeral.value = "";
};



const aoRetornarRequisicoes = async ()=>{

    if(UtilArray.isEmpty(requisicoesDeCompraSelecionadas.value)){
        return false;
    }

    retornandoRequisicoes.value = true;

}


const aoDecidirRetornarRequisicoes = async (decisao)=>{

    if(decisao.resultado == true){

        let requisicoesDeCompraIDs = requisicoesDeCompraSelecionadas.value.map(({id})=>id);

        let justificativa = `Retornado para LC\nJustificativa:${decisao.justificativa}`;

        let requisicoesRetornadasResponse = await RequisicaoDeCompraService.retornarRequisicoes(requisicoesDeCompraIDs,justificativa);
        if(requisicoesRetornadasResponse.status != 200){
            throw new Error("Falha ao retornar as Requisições para o Coordenador"); 
        }

    }

    retornandoRequisicoes.value = false;
    loadRequisicoesDeCompras();

}

const aoCriarCotacoes = async ()=>{

    if(UtilArray.isEmpty(requisicoesDeCompraSelecionadas.value)){
        return false;
    }

    criandoCotacoes.value = true;

    let requisicoesDeCompraIDs = requisicoesDeCompraSelecionadas.value.map(({id})=>id);

    let cotacaoResponse = await CotacaoDePedidoDeCompraService.criarCotacao(requisicoesDeCompraIDs, colaboradorStore.colaborador);
    if(cotacaoResponse.status != 200){
        throw new Error("Falha ao criar a Cotação"); 
    }
    
    criandoCotacoes.value = false;

    loadRequisicoesDeCompras();

}



onMounted(async ()=>{

   await loadRequisicoesDeCompras();

});




watch(retornandoRequisicoes, (novoValor) => {
    controlesDesativados.value = novoValor;
});

watch(criandoCotacoes, (novoValor) => {
    controlesDesativados.value = novoValor;
});


</script>

<template>

    <main 
        class="c-main"
        :class="{ 'c-main--disabled': controlesDesativados }"
    >

        <h2>
            Criar Cotação de Pedido de Compra
        </h2>

        <v-card>

            <v-card-title
                class="c-table-holder"
            >

                <h3
                    class="c-table__titulo"
                >
                    Requisições de Compra
                </h3>

                <div
                    class="c-table__buscas"
                >

                    <v-select
                        label="Job"
                        class="c-busca__job"
                        v-model="jobSelecionado"
                        :items="jobs"
                        :item-props="true"
                        item-text="codigo"
                        hide-details
                        outlined
                        return-object
                        clearable
                        :disabled="controlesDesativados"
                    ></v-select>

                    <v-select
                        label="OS"
                        class="c-busca__os"
                        v-model="ordemDeServicoSelecionada"
                        :items="ordensDeServico"
                        :item-props="true"
                        item-text="codigo"
                        hide-details
                        outlined
                        return-object
                        clearable
                        :disabled="controlesDesativados"
                    ></v-select>

                    <v-select
                        label="Palavras Chaves"
                        class="c-busca__palavraChave"
                        v-model="palavraChaveSelecionada"
                        :items="palavrasChave"
                        :item-props="true"
                        item-text="codigo"
                        hide-details
                        outlined
                        return-object
                        clearable
                        disabled
                    ></v-select>

                    <v-text-field
                        label="Buscar"
                        class="c-busca__geral"
                        v-model="buscaGeral"
                        append-icon="mdi-magnify"
                        single-line
                        hide-details
                        outlined
                        clearable
                        :disabled="controlesDesativados"
                    >
                    </v-text-field>

                </div>

                <div
                    class="c-table__controles"
                >
                
                    <div
                        class="c-controles__compradores"
                    >

                        <v-chip
                            class="c-comprador"
                            label
                        >

                            <v-icon left>
                                mdi-account-circle-outline
                            </v-icon>
                            Comprador:
                            {{compradorNome}}

                        </v-chip>

                    </div>

                    <div
                        class="c-controles__botao-esquerda"
                    >

                        <v-tooltip bottom>

                            <template v-slot:activator="{ on, attrs }">

                                <v-btn
                                    color="primary"
                                    elevation="2"
                                    v-bind="attrs"
                                    v-on="on"
                                    v-on:click="aoRetornarRequisicoes"
                                    :disabled="controlesDesativados"
                                    :loading="retornandoRequisicoes"
                                >
                                    Retornar
                                
                                </v-btn>

                            </template>

                            <span>Retornar itens para o Coordenador</span>

                        </v-tooltip>

                    </div>

                    <div
                        class="c-controles__botao-direita"
                    >

                        <v-tooltip bottom>

                            <template v-slot:activator="{ on, attrs }">

                                <v-btn
                                    color="primary"
                                    elevation="2"
                                    v-bind="attrs"
                                    v-on="on"
                                    @click="aoCriarCotacoes"
                                    :disabled="controlesDesativados"
                                    :loading="criandoCotacoes"
                                >

                                    Cotar
                                    
                                </v-btn>

                            </template>

                            <span>Colocar as requisições em uma Cotação</span>

                        </v-tooltip>

                    </div>

                </div>

            </v-card-title>

            <v-data-table
                class="c-table elevation-1"
                v-model="requisicoesDeCompraSelecionadas"
                :headers="requisicoesDeCompraHeaders"
                :items="requisicoesDeCompra"
                :search="buscaGeral"
                :items-per-page="-1"
                select-strategy="all"
                item-key="id"
                show-select
                return-object
                :loading="requisicoesDeCompraLoading"
                loading-text="Carregando... Por favor, aguarde."
            >

                <template v-slot:item.osItemDescricao="{ item }">

                    <p
                        class="c-cell__descricao"
                    >

                        {{item.osItemDescricao}}

                    </p>

                </template>

                <template v-slot:item.osItemValorDisponivel="{ item }">

                    <vuetify-money
                        type="number"
                        v-model="item.osItemValorDisponivel"
                        :readonly=true
                        backgroundColor="transparent"
                        :options="{
                            prefix:'R$',
                            precision:2
                        }"
                    ></vuetify-money>
                    
                </template>
        
            </v-data-table>

        </v-card>

        <RetornarRequisicaoModal
            :aberto="retornandoRequisicoes"
            @update:aberto="aoDecidirRetornarRequisicoes"
        ></RetornarRequisicaoModal>

    </main>

</template>

<style scoped>

.c-main{
    display: grid;
    gap: 15px;
}

.c-main--disabled{
    pointer-events: none;
    user-select: none; 
}

.c-main--disabled >>> .c-table__header{
    pointer-events: none;
    user-select: none; 
}

.c-table-holder{
    display: grid; 
    grid-template-columns: 1fr 1fr; 
    grid-template-rows: 1fr auto; 
    grid-template-areas: 
    "titulo ."
    "buscas controles";
    gap: 10px;
}

.c-table__title { 
    grid-area: titulo;
}

.c-cell__descricao{
    white-space: normal;
    margin: 0px !important;
}

.c-table__buscas { 
    grid-area: buscas;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr; 
    grid-template-rows: 1fr auto; 
    gap: 10px;
    grid-template-areas: 
        "buscaJob buscaOS buscaPalavraChave"
        "buscaGeral buscaGeral buscaGeral";
}

.c-busca__job{
    grid-area: buscaJob;
}

.c-busca__os{
    grid-area: buscaOS;
}

.c-busca__palavraChave{
    grid-area: buscaPalavraChave;
}

.c-busca__geral{
    grid-area: buscaGeral;
}

.c-comprador{
    width: 100%;
    min-height: 48px;
}

.c-comprador >>> .v-chip__content{
    margin: auto;
}

.c-table__controles { 
    grid-area: controles;
    display: grid;
    grid-template-areas: 
    "compradores compradores"
    "botao-esquerda botao-direita";
    padding: 0 20px;
    gap: 10px;
}

.c-controles__compradores { 
    grid-area: compradores;
}

.c-controles__botao-esquerda { 
    grid-area: botao-esquerda;
    display: grid;
    grid-auto-flow: column;
}

.c-controles__botao-direita { 
    grid-area: botao-direita;
    display: grid;
    grid-auto-flow: column;
}

.c-table{
    display: grid;
    white-space: nowrap;
}

.c-table{
    display: grid;
    white-space: nowrap;
}

@media (width <= 850px) {
    
    .c-table-holder{
        grid-template-columns: 1fr; 
        grid-template-rows: auto 1fr auto; 
        grid-template-areas:
            "titulo"
            "controles"
            "buscas"
        ;
    }

    .c-table__controles{
        padding: 0;
    }

}

</style>